module.exports = __webpack_public_path__ + "img/login.fb16d825.svg";